/*** API SERVICE
 * ihr-amp
 * 
*/

// iHR AMP API Config
const ihrAmpApiConfig = {
  endpoint: process.env["REACT_APP_IHR_AMP_ENDPOINT"],
  podcast: {
    follows: '/podcast/follows',
    searchByName: '/search/all',
    putFollow: '/podcast/follows/'
  }
};

/*** LOG CONFIG */
// use this to enable various logs
// error logging always enabled
/* const logConfig = {
  name: 'ihr-amp-api.service',
  default: true,
  errors: true,
  extended: {
    getPodcastFollows: true,
    searchPodcastShows: true,
    putFollowPodcastById: true,
  },
}; */

const generateUrlWithParams = (apiEndpoint, urlQueryParams) => {
  const url = new URL(apiEndpoint);
  Object.keys(urlQueryParams).forEach(key => url.searchParams.append(key, urlQueryParams[key]));
  return url
}

export const putFollowPodcastById = async (headers, podcastId) => {
  //console.debug(logConfig.name+ ' - putFollowPodcastById - headers', {headers: JSON.stringify(headers), podcastId})
  headers['Content-Type'] = 'text/html';
  headers['Accept'] = 'application/json';
  const requestOptions = {
    method: 'PUT',
    headers
  };
  //console.debug('putFollowPodcastById - requestOptions', requestOptions);

  try {
    const res = await fetch(ihrAmpApiConfig.endpoint + ihrAmpApiConfig.podcast.putFollow + podcastId, requestOptions)
    //const resJSON = await res.json();
    //console.debug('putFollowPodcastById - res', res);
    if (res.ok) {
      const responseBody = {
        id: podcastId,
        status: 'success'
      }
      return responseBody;
    }
    throw res
  } catch (error) {
    //console.debug('putFollowPodcastById - error', error);
    let errorBody
    if (error.type) {
      errorBody = error
    } else {
      errorBody = {
        type: 'putFollowPodcastById',
        message: 'Add Podcast Follow Failed',
        rawError: error && error.message ? error.message : error,
      }
    }
    throw(errorBody)
  }
}

export const getPodcastFollows = async (headers) => {
  //console.debug(logConfig.name+ ' - getPodcastFollows - headers', JSON.stringify(headers))

  const requestOptions = {
    method: 'GET',
    //url: ihrAmpApiConfig.endpoint + ihrAmpApiConfig.podcast.follows,
    headers
  };
  //console.debug('getPodcastFollows - requestOptions', requestOptions);

  try {
    const res = await fetch(ihrAmpApiConfig.endpoint + ihrAmpApiConfig.podcast.follows, requestOptions)
    const resJSON = await res.json();
    //console.debug('getPodcastFollows - resJSON', resJSON);
    if (res.ok) {
      return resJSON;
    }
    throw resJSON
  } catch (error) {
    //console.debug('getPodcastFollows - error', error);
    let errorBody
    if (error.type) {
      errorBody = error
    } else {
      errorBody = {
        type: 'getPodcastFollows',
        message: 'Get Podcast Follows Failed',
        rawError: error && error.message ? error.message : error,
      }
    }
    throw(errorBody)
  }
}

export const searchPodcastShows = async (headers, keywords) => {
  //console.debug(logConfig.name+ ' - searchPodcastShows', {headers: JSON.stringify(headers), keywords})

  const params = {
    keywords: keywords,
    podcast: true,
    maxRows: 4,
    track: false,
    artist: false,
    bundle: false,
    station: false,
  }
  const url = generateUrlWithParams(ihrAmpApiConfig.endpoint + ihrAmpApiConfig.podcast.searchByName, params);
  //console.debug('searchPodcastShows - url', url);

  const requestOptions = {
    method: 'GET',
    //url: ihrAmpApiConfig.endpoint + ihrAmpApiConfig.podcast.follows,
    headers
  };
  //console.debug('searchPodcastShows - requestOptions', requestOptions);

  try {
    const res = await fetch(url, requestOptions)
    const resJSON = await res.json();
    //console.debug('searchPodcastShows - resJSON', resJSON);
    if (res.ok) {
      //test if any search results were found
      if (resJSON.results.podcasts.length !== 0) {
        const foundBestMatch = resJSON.results.podcasts.filter(podcast => podcast.id === resJSON.bestMatch.id);
        //console.debug('searchPodcastShows - foundBestMatch', foundBestMatch);
        const bestMatch = {
          ...resJSON.bestMatch,
          podcast: foundBestMatch.length !== 0 ? foundBestMatch[0] : null,
        }
        //console.debug('searchPodcastShows - bestMatch', bestMatch);
        return {
          podcasts: resJSON.results.podcasts, 
          bestMatch: bestMatch
        };
      }
    }
    throw resJSON
  } catch (error) {
    //console.debug('searchPodcastShows - error', error);
    let errorBody
    if (error.type) {
      errorBody = error
    } else {
      errorBody = {
        type: 'searchPodcastShows',
        message: 'Search Podcast Shows Failed',
        rawError: error && error.message ? error.message : error,
      }
    }
    throw(errorBody)
  }
}